export const mapArrayToQueryParams = (values: unknown[], paramName: string) => {
  return values.map(value => `${paramName}=${value}`).join('&')
}
